/* @flow */

import type { BasicFunction, BasicPromiseFunction } from '../../../../helpers/jsHelpers/types';
import type { BO_API_ERROR_TYPE } from '../../../../redux/netgemApi/actions/videofutur/types/common';

import { logError } from '../../../../helpers/debug/debug';
import { PlayerError } from '../../../../helpers/player/PlayerError';
import { CustomNetworkError } from '../CustomNetworkError';

/*
 * Called from a catch() block to filter out canceled promises (i.e. aborted signals)
 * If promise was canceled, nothing is done
 * Otherwise, error is logged and given callback is called
 */
const ignoreIfAborted: (signal: AbortSignal, error: Error | PlayerError | CustomNetworkError | BO_API_ERROR_TYPE, callback?: BasicFunction | BasicPromiseFunction) => Promise<void> = (
  signal,
  error,
  callback,
) => {
  if (signal.aborted || (error instanceof DOMException && error.name === 'AbortError')) {
    return Promise.resolve();
  }

  logError('Rejected promise:');
  logError(error instanceof CustomNetworkError ? error.networkError : error);

  if (!callback) {
    return Promise.resolve();
  }

  // Callback is only executed if promise has been rejected, but not canceled
  const result = callback();

  if (result instanceof Promise) {
    // BasicPromiseFunction
    return result;
  }

  return Promise.resolve();
};

export { ignoreIfAborted };
